import { Directive, ElementRef, Input, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { PageHeaderService } from '@app/misc/page-header/page-header.service';

@Directive({ selector: '[mobileMenuItem][mobileMenuItemKey]' })
export class HeaderMobileMenuItemDirective implements AfterViewInit, OnDestroy {
  /**
   * @deprecated `mobileMenuItemIcon` is deprecated and will be removed in the future.
   * We no longer need to show icons in the mobile menu.
   */
  @Input() public mobileMenuItemIcon: string;
  @Input() public mobileMenuItemKey: string;
  @Input() public mobileMenuItemSubText: string = '';

  constructor(
    private el: ElementRef,
    private pageHeaderService: PageHeaderService,
    private renderer: Renderer2,
  ) {}

  public ngAfterViewInit(): void {
    this.setMenuItem();
  }

  public ngOnDestroy(): void {
    this.pageHeaderService.removeMobileMenuItem(this.mobileMenuItemKey);
  }

  private setMenuItem(): void {
    const nativeElement: HTMLButtonElement = this.el.nativeElement;
    this.pageHeaderService.addMobileMenuItem({
      label: nativeElement.textContent,
      click: nativeElement.click.bind(nativeElement),
      shouldShowItem: true,
      iconSrc: this.mobileMenuItemIcon,
      key: this.mobileMenuItemKey,
      isDisabled: nativeElement.disabled || nativeElement.getAttribute('disabled') === 'true',
      subtext: this.mobileMenuItemSubText,
    });
    this.renderer.addClass(nativeElement, 'hide-sm');
  }
}